import * as React from 'react';

import { Title } from 'common/components';
import { useCreationDefaults } from 'common/hooks';
import { Section } from 'templates/core';
import WorkoutCore from '../components/WorkoutCore';

const WorkoutCreate = () => {
  const defaultValues = useCreationDefaults();

  return (
    <>
      <Section>
        <Title size="big">Create workout</Title>
      </Section>
      <WorkoutCore defaultValues={defaultValues} layout="creation" />
    </>
  );
};

export default WorkoutCreate;
